import { getSentryInstance } from '~/sentry';

export type MarketplaceAction =
  | 'order_placed'
  | 'order_updated'
  | 'order_cancelled'
  | 'counter_created'
  | 'counter_updated'
  | 'counter_accepted'
  | 'counter_declined'
  | 'counter_withdrawn'
  | 'counter_trade_executed'
  | 'liquidity_order_updated'
  | 'liquidity_orders_cancelled';

const actionEntity: Record<MarketplaceAction, 'order' | 'counter'> = {
  order_placed: 'order',
  order_updated: 'order',
  order_cancelled: 'order',
  counter_created: 'counter',
  counter_updated: 'counter',
  counter_accepted: 'counter',
  counter_declined: 'counter',
  counter_withdrawn: 'counter',
  counter_trade_executed: 'counter',
  liquidity_order_updated: 'order',
  liquidity_orders_cancelled: 'order',
};

function actionLabel(action: MarketplaceAction) {
  return action.replace(/_/g, ' ');
}

export function tagMarketplaceTradingActivity(
  action: MarketplaceAction,
  data?: Record<string, unknown>
) {
  const sentry = getSentryInstance();
  if (!sentry) return;

  const entity = actionEntity[action];

  try {
    sentry.setTag('marketplace_traded', 'true');
    sentry.setTag('marketplace_last_action', action);
    sentry.setTag('marketplace_last_entity', entity);
    sentry.addBreadcrumb({
      category: `marketplace.${entity}`,
      message: `Marketplace ${actionLabel(action)}`,
      level: 'info',
      data,
    });
  } catch (error) {
    console.warn('Failed to tag marketplace trading activity', error);
  }
}
